import React, { useState } from 'react';
import '../../styles/horeca/horecaoffering.css';
import AnimatedArrowButton from '../AnimatedArrowButton';
import AnimationBox from '../../animationBox';

import icon1 from '../../assets/o1.png';
import icon2 from '../../assets/o2.png';
import icon3 from '../../assets/o3.png';
import icon4 from '../../assets/o4.png';


const HorecaOffering = () => {
    

    return(
    <div className='offering-container'>
    <AnimationBox>
    <div className='horeca-offering'>
        
            <div className='offering-inner'>
                <div className='offering-box1'>
                    <div className='myoffering' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        <div className='offering-icon'>
                            <img src={icon1} width='35px' height='35px' ></img>
                        </div>
                        <div className='offering-msg' style={{textAlign:'left'}}>
                            <h4>Fresh Produce</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Vibrant fruits and vegetables sourced for freshness.</p>
                        </div>
                    </div>
                    <div className='myoffering' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        <div className='offering-icon'>
                            <img src={icon2} width='35px' height='35px' ></img>
                        </div>
                        <div className='offering-msg' style={{textAlign:'left'}}>
                            <h4>Meat & SeaFood</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Premium-grade halal meats and sustainable seafood.</p>
                        </div>
                    </div>
                    <div className='myoffering' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838',gap:'10px'}}>
                        <div className='offering-icon'>
                            <img src={icon3} width='35px' height='35px' ></img>
                        </div>
                        <div className='offering-msg' style={{textAlign:'left'}}>
                            <h4>Dairy & Bakery</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Artisanal breads, pastries, and dairy essentials.</p>
                        </div>
                    </div>
                    <div className='myoffering' style={{display:'flex',padding:'25px',gap:'10px'}}>
                        <div className='offering-icon'>
                            <img src={icon4} width='35px' height='35px' ></img>
                        </div>
                        <div className='offering-msg' style={{textAlign:'left'}}>
                            <h4>Gourmet Ingredients</h4>
                            <p style={{color:'white', fontSize:"14px"}}>Enhance your culinary creations with spices, oils, and condiments.</p>
                        </div>
                    </div>

                </div>
                <div className='offering-box2'>
                <div className='myoffering' style={{display:'flex',padding:'25px',borderBottom:'1px solid #383838', height:'15%',gap:'10px'}}>
                        
                            <h4 style={{color:'#FFD52B'}}>Key Offering</h4>
                            
                </div>
                    <div className='myoffering' style={{display:'flex',padding:'25px', height:'85%',gap:'10px',paddingTop:"60px"}}>
                        
                        <div className='offering-msg' style={{textAlign:'left'}}>
                            <h1 style={{fontWeight:"600"}}>Our Product<br></br> Categories</h1>
                            <p style={{color:'white', fontSize:"14px"}}>Explore our diverse range of high-quality food products tailored for hotels, restaurants, and catering services.</p>
                            <AnimatedArrowButton text="Learn More" link="/Horeca-Products"   />
                        </div>
                    </div>

                </div>

            </div>
        
    
    </div></AnimationBox> </div>);


}

export default HorecaOffering ;